import { memo } from "react";
import { RosterColumnHoverBackdrop } from "@/components/nurse/nurseVerticalGrid";
import { cn } from "@/utils/cn";
import { useRosterFocusStore } from "@/store/rosterFocusStore";
import type { PrevTailData } from "@/hooks/roster-craete/useRosterPrevTail";
import type {
  RosterTableLayout,
  RosterTableLayoutConfig,
} from "@/components/nurse/rosterColumnHoverLayout";

export type RosterTableBodyChromeProps = {
  daysInMonth: number;
  hasPrevTail: boolean;
  prevTailData?: PrevTailData | null;
  layout?: RosterTableLayout;
  layoutConfig?: RosterTableLayoutConfig;
  /** CREATE `compactVerticalPadding` 과 동일 */
  compactVerticalPadding?: boolean;
  unframed?: boolean;
  children: React.ReactNode;
};

/** 근무표 만들기·발행 조회 공통: 카드 테두리 + 열 호버 백드롭 */
export const RosterTableBodyChrome = memo(function RosterTableBodyChrome({
  daysInMonth,
  hasPrevTail,
  prevTailData,
  layout = "create",
  layoutConfig,
  compactVerticalPadding = false,
  unframed = false,
  children,
}: RosterTableBodyChromeProps) {
  const clearHoveredFocus = useRosterFocusStore((state) => state.clearHoveredFocus);

  return (
    <div className="rounded-lg relative">
      <div
        className={cn(
          "relative z-[1]",
          !unframed && "border border-border rounded-lg",
          unframed || compactVerticalPadding ? "p-0" : "p-0 py-2"
        )}
        onMouseLeave={(event) => {
          const nextTarget = event.relatedTarget;
          if (
            nextTarget instanceof HTMLElement &&
            nextTarget.closest("[data-monthly-memo-post-it]")
          ) {
            return;
          }

          clearHoveredFocus();
        }}
      >
        <RosterColumnHoverBackdrop
          daysInMonth={daysInMonth}
          hasPrevTail={hasPrevTail}
          prevTailData={prevTailData}
          layout={layout}
          layoutConfig={layoutConfig}
        />
        {children}
      </div>
    </div>
  );
});
